var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E01C1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55822 8.72582L9.64201 15.2722C9.69158 15.5719 9.84594 15.8442 10.0776 16.0407C10.3092 16.2372 10.6031 16.3451 10.9069 16.3452H12.6241M16.0596 8.72582L14.9763 15.2722C14.9268 15.5719 14.7724 15.8442 14.5408 16.0407C14.3091 16.2372 14.0153 16.3451 13.7115 16.3452H11.9942M11.2946 11.2407V13.8304M13.3237 11.2407V13.8304M7.5647 8.72582H17.0537M13.7335 8.72582V7.81283C13.7335 7.60878 13.6525 7.41309 13.5082 7.2688C13.3639 7.12452 13.1682 7.04346 12.9642 7.04346H11.6542C11.4501 7.04346 11.2544 7.12452 11.1102 7.2688C10.9659 7.41309 10.8848 7.60878 10.8848 7.81283V8.72582H13.7335Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.ef6ee437dfe2b94d7ba9d0af05122acf.svg";
export { ForwardRef as ReactComponent };